import styled from 'styled-components'

export const Container = styled.section`
    float: left;
    width: 100%;
    position: relative;
    padding: 150px 60px 60px 60px;
    background: url(${props => props.bgDesktop }) top center #060d15 no-repeat;
    display: flex;
    justify-content: center;

    @media (max-width: 1400px) {
        padding: 40px;
    }

    @media (max-width: 1000px) {
        padding: 40px 20px 40px 20px;
        background: url(${props => props.bgMobile }) bottom center #060d15 no-repeat;
        background-size: 100% auto;
    }

`

export const ContainerInterno = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    max-width: 1310px;

    @media (max-width: 1000px) {
        flex-direction: column-reverse;
    }
`

export const BoxCol6 = styled.div`
    float: left;
    width: 50%;
    padding: 0 15px;
    text-align: center;

    @media (max-width: 1400px) {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 0;

        &.boxTextos {
            margin-top: 200px;
        }
    }

    @media (max-width: 768px) {
        &.boxTextos {
            margin-top: 400px;
        }
    }

    @media (max-width: 768px) {
        &.boxTextos {
            margin-top: 200px;
        }
    }
`

export const ImagemPrincipal = styled.img`
    max-width: 100%;
    margin-bottom: 20px;

    @media (max-width: 768px) {
        max-width: 70%;
    }
`

export const TextoBanner = styled.span`
    float: left;
    width: 100%;
    color: #fff;
    font-size: 16px;
    line-height: 26px;
    font-weight: 500;

    strong {
        color: #FFC455;
        font-weight: 900;
    }

    &+ span {
        margin-top: 20px;
    }

    @media (max-width: 1600px) {
        br {
            display: none;
        }
    }

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 25px;
        margin-bottom: 0;
    }
`

export const LegendaBanner = styled.span `
    float: left;
    width: 100%;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
`

export const BoxTag = styled.div `
    float: left;
    width: 100%;
    background: #2B2B2B;
    padding: 15px;
    border-radius: 8px;

    @media (max-width: 768px) {
        padding: 10px;
    }
`

export const BoxTagTexto = styled.span `
    color: #F09C00;
    font-size: 22px;
    font-weight: 500;
    line-height: 32px;

    strong {
       color: #FFC455;
    }

    @media (max-width: 768px) {
        font-size: 14px;
        line-height: 24px;
    }
`

export const BoxAssinaturas = styled.div `
    float: left;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 20px;

    @media (max-width: 1400px) {
        gap: 20px;
    }

    @media (max-width: 768px) {
        gap: 5px
    }
`

export const ItemAssinatura = styled.div `
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 15px;

    @media (max-width: 768px) {
        padding: 10px;
    }

    @media (max-width: 500px) {
        padding: 7px;
    }
`

// Tag Relâmpago

export const ItemAssinaturaTagRelampago = styled.div `
    background-color: ${props => props.primeiro ? '#DC9A4C' : '#565769' };
    float: left;
    width: 100%;
    border-radius: 100px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 500px) {
        border-radius: 8px;
        padding: 7px;
    }
`

export const ItemAssinaturaTagRelampagoImg = styled.img `
    width: 20px;

    @media (max-width: 500px) {
        display: none;
    }
`

export const ItemAssinaturaTagRelampagoTextos = styled.div `
    flex: 1;
    display: flex;
    flex-direction: column;
`

export const ItemAssinaturaTagRelampagoTextosTitulo = styled.span `
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    font-style: italic;
    margin-bottom: 5px;

    @media (max-width: 500px) {
        font-size: 12px;
        margin-bottom: 2px;
    }
    
`

export const ItemAssinaturaTagRelampagoTextosLegenda = styled.span `
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.5px;

    @media (max-width: 500px) {
        font-size: 10px;
    }
`

// Tag Normal

export const ItemAssinaturaTag = styled.span `
    background-color: ${props => props.primeiro ? '#475569' : '#171717' };
    float: left;
    width: 100%;
    border-radius: 100px;
    padding: 10px;
    text-align: center;
    font-size: 13px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;

    @media (max-width: 768px) {
        font-size: 11px;
        line-height: 22px;
        padding: 5px;
    }
`

// Título Card

export const ItemAssinaturaTitulo = styled.span `
    float: left;
    width: 100%;
    color: #121520;
    font-size: 24px;
    font-weight: 900;
    margin: 20px 0 10px 0 ;
    padding: 0 30px;
    line-height: 34px;

    @media (max-width: 1600px) {
        padding: 0;
        font-size: 18px;
        line-height: 26px;
    }

    @media (max-width: 768px) {
        font-size: 16px;
        line-height: 22px;
        margin: 10px 0 15px 0;
    }
`

// Lista Bônus

export const ListaBonus = styled.ul `
    float: left;
    width: 100%;
    padding: 0;
    margin: 0 0 20px 0;
`

export const ListaBonusItem = styled.li `
    float: left;
    width: 100%;
    text-align: center;
    list-style: none;
    font-size: 13px;
    font-weight: 600;

    + li {
        margin-top: 3px;
    }
`

// Preço DE

export const ItemAssinaturaPrecoDe = styled.span `
    float: left;
    width: 100%;
    color: #565769;
    text-decoration: line-through;
    font-size: 14px;
    margin-bottom: 5px;

    @media (max-width: 768px) {
        font-size: 13px;
    }
`

// Preço POR

export const ItemAssinaturaPrecoPor = styled.span `
    float: left;
    width: 100%;
    color: #121520;
    font-size: 14px;

    strong {
        font-size: 28px;
        font-weight: 900;
        letter-spacing: -1px;

        @media (max-width: 768px) {
            font-size: 20px;
            letter-spacing: -0.5px;
        }
    }

    @media (max-width: 768px) {
        font-size: 12px;
    }
`

export const ItemAssinaturaLinkCartao = styled.a `
    float: left;
    width: 100%;
    margin: 20px 0 10px 0;
    padding: 10px 5px;
    font-size: 14px;
    border-radius: 8px;
    font-weight: bold;
    color: #F09C00;
    border: solid 2px #F09C00;

    @media (max-width: 768px) {
        margin: 15px 0 5px 0;
        padding: 10px 5px;
        font-size: 10px;
    }
`

export const ItemAssinaturaLinkAVista = styled.a `
    float: left;
    width: 100%;
    color: #fff;
    padding: 10px 5px;
    font-size: 14px;
    border-radius: 8px;
    font-weight: bold;
    background-color: #C98400;

    @media (max-width: 768px) {
        padding: 10px 5px;
        font-size: 10px;
    }
`

export const TextoBaixo = styled.span `
    float: left;
    width: 100%;
    color: #fff;
    margin-top: 40px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 13px;
    line-height: 25px;
    letter-spacing: 2px;

    @media (max-width: 768px) {
        margin-top: 25px;
        font-size: 12px;

        br {
            display: none;
        }
    }
`
